module.exports = "/assets/site/images/gal_csaba.jpg?80b1567a7cd381e4333ceaf3a4911acf";